import React, { useEffect, useState } from 'react';
import AreaService from "../../../../../api/areaService";
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import Loader1 from "../../../../../CommonElements/Spinner/loader";
import { FaRegListAlt } from 'react-icons/fa';
import { TbClockCancel } from "react-icons/tb";
import { FaRegHourglass } from 'react-icons/fa';
import { ImCheckboxChecked } from "react-icons/im";
import PreviousTicketCard from '../../../../Screens/GlobalUser/SupportAndTicketss/Component/NewDesignPreviousTickets/PreviousTicketCardNewDesign';
import TableComponentForData from '../Components/EditModal/Edit_Modal_New';
import DataTable from 'react-data-table-component';
import '../Styling/itStyle.css';

const ItSupportNew = () => {
  const [tickets, settickets] = useState([])
  const [modal, setModal] = useState(false);
  const [selectedTicket, setselectedTicket] = useState()
  const [loader, setloader] = useState(true)
  const [btnload, setbtnload] = useState(false)
  const [activeFilter, setActiveFilter] = useState('all');
  const [showSelectedCard, setShowSelectedCard] = useState(false);
  const [statusCounts, setStatusCounts] = useState([
    { status: 'Pending', count: 0 },
    { status: 'In Process', count: 0 },
    { status: 'Resolved', count: 0 },
    { status: 'Total', count: 0 }
  ]);

  function handleUpdateclick(item) {
    setselectedTicket(item)
    toggle()
  }

  const handleRowClick = (row) => {
    setselectedTicket(row);
    setShowSelectedCard(true);
  };

  const handleBackToTable = () => {
    setShowSelectedCard(false);
  };

  const handleupdateReq = async (e) => {
    console.log('eeeee', e)
    try {
      setbtnload(true)
      const res = await AreaService.handleTicketUpdateReq(e);
      console.log(res.data.data.id,res.data.data.status)
      if (res.data) {
        const currentDate = new Date().toISOString();
        settickets(prevTickets =>
            prevTickets.map(ticket =>
                ticket.id === res.data.data.id
                ? { ...ticket, status: res.data.data.status,response:e.response,responseDate:currentDate }
                : ticket
            )
        );
      setbtnload(false)
        toggle();
        setShowSelectedCard(false);
    }
    } catch (error) {
      console.log('error while updating ticket', error)
      alert('Error while updating ticket')
    }
  }

  const toggle = () => setModal(!modal);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const getFilteredTickets = () => {
    if (activeFilter === 'all') return tickets;
    return tickets.filter(ticket =>
      activeFilter === 'closed' ? ticket.status?.toLowerCase() === 'closed' :
      activeFilter === 'open' ? ticket.status?.toLowerCase() === 'open' :
      activeFilter === 'resolved' ? ticket.status === 'resolved' : true
    );
  };

  // DataTable columns configuration
  const columns = [
    {
      name: 'Ticket ID',
      selector: row => row.id,
      sortable: true,
      center: true,
    },
    {
      name: 'Generated By',
      selector: row => row.owner,
      sortable: true,
      center: true,
    },
    {
      name: 'Issue Date',
      selector: row => row.ticketDate,
      sortable: true,
      center: true,
    },
    {
      name: 'Module',
      cell: row => (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          {row.models && row.models.length > 0 ? (
            <>
              <span
                className='p-1 moduleSubHeading'
                style={{
                  background: '#E9F6FC',
                  borderRadius: '4px',
                  color: '#1E84B0',
                  fontSize: '12px',
                  marginRight: '4px'
                }}
              >
                {row.models[0].name}
              </span>
              {row.models.length > 1 && (
                <span
                  className='p-1 moduleSubHeading'
                  style={{
                    background: '#E9F6FC',
                    borderRadius: '4px',
                    color: '#1E84B0',
                    fontSize: '12px'
                  }}
                >
                  {row.models[1].name}
                </span>
              )}
              {row.models.length > 2 && (
                <span
                  className='p-1 ms-1'
                  style={{
                    background: '#f0f0f0',
                    borderRadius: '4px',
                    color: '#666',
                    fontSize: '12px'
                  }}
                >
                  +{row.models.length - 2}
                </span>
              )}
            </>
          ) : (
            <span>-</span>
          )}
        </div>
      ),
      center: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      center: true,
      cell: row => (
        <span
          className='p-1'
          style={{
            background: row.status?.toLowerCase() === 'closed' ? '#b3ebae' :
                     row.status === 'in process' ? '#FFF7E6' : '#F7F8F9',
            borderRadius: '4px',
            color: row.status === 'resolved' ? '#43953B' :
                   row.status === 'in process' ? '#D99104D9' : 'black',
            padding: '3px 8px',
            fontSize: '12px'
          }}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: 'Priority',
      selector: row => row.priority,
      sortable: true,
      center: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          
            <Button
              className="edit-btn edit-btn-new"
              
              size="sm"
              outline
              disabled={row.status?.toLowerCase() === 'closed'}
              style={{cursor: row.status?.toLowerCase() === 'closed' ? 'not-allowed' : 'pointer', }}
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                handleUpdateclick(row);
              }}
            >
              Update
            </Button>
        
        </div>
      ),
      center: true,
    },
  ];

  const getData = async () => {
    try {
      const res = await AreaService.getDataforItTickets();
      const counts = [
        { status: 'Pending', count: res.data.data.tickets.filter(ticket => ticket.status === 'pending').length },
        { status: 'In Process', count: res.data.data.tickets.filter(ticket => ticket.status === 'in process').length },
        { status: 'Resolved', count: res.data.data.tickets.filter(ticket => ticket.status === 'resolved').length },
        { status: 'Total', count: res.data.data.tickets.length }
      ];

      console.log(counts,'all count of tickets')
      setStatusCounts(counts);
      settickets(res.data.data.tickets);
      setloader(false)
    } catch (error) {
      console.log('error while fetching tickets data', error)
    }
  }

  useEffect(() => {
    getData();
  }, [])
  // async function SubStatus(){
  //   // const id = 78
  //   const id = [38,43,44,40,46,47,48,49,50,51,52,55,56,57,58,59,60,63,67,68,69,70,72,74,75,76,77,
  //               80,82,83,84,85,86,90,92,93,94,95,96,100,101,102,103,104,105,106,107,108,109,110,111,
  //               115,117,121,123,125,126,127,128,129,130,131,132,135,137,143,144,146,148,149,150,152]
  //   const res = await AreaService.sub_area_status(id);
  //   console.log(res)
  //  }
  return (
    <>
      <br />
      <Container fluid={true}>
        <h5 style={{ fontSize: '22px' }}>Generated Tickets</h5>
        {loader ? (
          <center style={{ marginTop:'60px' }}>
            <Loader1 />
          </center>
        ) : (
          <>
            <Row>
              {/* Status count cards */}
              {statusCounts?.sort((a, _) => a.status === "Total" ? -1 : a.status === "Pending" ? 0 : a.status === "In Process" ? 1 : 2)
                .map((data) => (
                  <Col xs='12' sm='6' lg='4' xl='3' key={data.status}>
                    <Card className={` ${data.status==='Total'?'b-l-info': data.status==='Pending'?'b-l-danger':data.status==='Resolved'?'b-l-success':data.status==='In Process'?'b-l-warning':null}`}>
                      <CardBody className='d-flex justify-content-center flex-column align-items-center' style={{height:'150px'}}>
                        <div className='mb-2'>
                          {data.status === 'Total' ? <FaRegListAlt style={{ color: '#5f6a6a', fontSize: '25px' }} />
                            : data.status === 'Pending' ? <TbClockCancel style={{ color: '#FC4438', fontSize: '25px' }} />
                              : data.status === 'In Process' ? <FaRegHourglass style={{ color: '#ffc107', fontSize: '25px' }} />
                                : data.status === 'Resolved' ? <ImCheckboxChecked style={{ color: '#28a745', fontSize: '25px' }} />
                                  : null}
                        </div>
                        <h6>
                          {data.status} : <span>{data.count}</span>
                        </h6>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              }
            </Row>

            <Row className="mt-4">
              <Col xs="12">
                {showSelectedCard ? (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5>Ticket Details</h5>
                      <Button color="secondary" onClick={() => setShowSelectedCard(false)}>
                        Back to Table
                      </Button>
                    </div>
                    <PreviousTicketCard
                      data={selectedTicket}
                      itmode={true}
                      toggle={() => handleUpdateclick(selectedTicket)}
                    />
                  </div>
                ) : (
                  <Card>
                    <CardBody>
                      <div className="mb-3">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeFilter === 'all' ? 'active' : ''}`}
                              href="#"
                              onClick={() => handleFilterChange('all')}
                            >
                              All
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeFilter === 'open' ? 'active' : ''}`}
                              href="#"
                              onClick={() => handleFilterChange('open')}
                            >
                              Open
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeFilter === 'closed' ? 'active' : ''}`}
                              href="#"
                              onClick={() => handleFilterChange('closed')}
                            >
                              Closed
                            </a>
                          </li>
                          {/* <li className="nav-item">
                            <a
                              className={`nav-link ${activeFilter === 'resolved' ? 'active' : ''}`}
                              href="#"
                              onClick={() => handleFilterChange('resolved')}
                            >
                              Resolved
                            </a>
                          </li> */}
                        </ul>
                      </div>

                      <DataTable
                        columns={columns}
                        data={getFilteredTickets().sort((a, b) => b.id - a.id)}
                        pagination
                        highlightOnHover
                        responsive
                        striped
                        pointerOnHover
                        onRowClicked={handleRowClick}
                        customStyles={{
                          headRow: {
                            style: {
                              backgroundColor: '#f8f9fa',
                              fontWeight: 'bold',
                            },
                          },
                          rows: {
                            style: {
                              minHeight: '60px',
                            },
                          },
                        }}
                      />
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>

            {/* Modal for updating tickets */}
            <TableComponentForData
              btnload={btnload}
              handleupdateReq={handleupdateReq}
              toggle={toggle}
              isOpen={modal}
              selectedTicket={selectedTicket}
            />
          </>
        )}
      </Container>
    </>
  )
}

export default ItSupportNew

